import { useEffect } from 'react';

/**
 * ScrollFix - A component that prevents horizontal scrolling on mobile devices
 */
const ScrollFix = () => {
  useEffect(() => {
    // Apply styles to prevent horizontal scrolling
    document.documentElement.style.overflowX = 'hidden';
    document.documentElement.style.maxWidth = '100%';
    document.body.style.overflowX = 'hidden';
    document.body.style.maxWidth = '100%';
    
    // No cleanup needed as we want this to persist
    return () => {};
  }, []);

  // This component doesn't render anything
  return null;
};

export default ScrollFix;